<template>
        <span @click="openAppointment(appointment)" >
            <v-icon v-if="icon != null"  :icon="icon" color="primary" class="cursor-pointer" size="x-large"/>
        </span>
        <AppointmentDialog ref="appointmentDialogRef" :data="appointmentData" />

</template>

<script setup>
    import { onBeforeMount, ref } from 'vue';
    import { mdiClipboardTextOutline } from '@mdi/js';
    import AppointmentDialog from '@/views/dialogs/ManageCustomer/AppointmentDialog.vue';

    const props = defineProps(['params']);
    const appointmentDialogRef = ref(null);
    const appointmentData = ref(null);

    const icons = {
        mdiClipboardTextOutline,
    };
    const icon = ref(null);
    const appointment = ref('');

    onBeforeMount(() => {
        if (!props.params.node.group && props.params.colDef.field == 'data' && props.params.value != null && props.params.value != '' && props.params.node.rowPinned != 'bottom') {
            icon.value = icons.mdiClipboardTextOutline;
            appointmentData.value = JSON.parse(props.params.value);
        }
    })

    function openAppointment() {
        appointmentDialogRef.value.open();
    }

</script>
